import { render } from "./OtherProjectsSection.vue?vue&type=template&id=bb5fea72&scoped=true"
import script from "./OtherProjectsSection.vue?vue&type=script&lang=js"
export * from "./OtherProjectsSection.vue?vue&type=script&lang=js"

import "./OtherProjectsSection.vue?vue&type=style&index=0&id=bb5fea72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5fea72"]])

export default __exports__